import { Auth } from "aws-amplify";

const COGNITO_PREFIX = "CognitoIdentityServiceProvider";
const LEGACY_ACCESS_KEY = "accessToken";
const LEGACY_ID_KEY = "idToken";
const LEGACY_REFRESH_KEY = "refreshToken";

export function readCognitoAccessTokenFromStorage() {
  if (typeof localStorage === "undefined") {
    return null;
  }
  let poolPrefix = null;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key &&
      key.startsWith(`${COGNITO_PREFIX}.`) &&
      key.endsWith(".LastAuthUser")
    ) {
      poolPrefix = key.slice(0, -".LastAuthUser".length);
      const username = localStorage.getItem(key);
      if (!username) {
        return null;
      }
      return localStorage.getItem(`${poolPrefix}.${username}.accessToken`);
    }
  }
  return null;
}

export function clearLegacyAppTokens() {
  localStorage.removeItem(LEGACY_ACCESS_KEY);
  localStorage.removeItem(LEGACY_ID_KEY);
  localStorage.removeItem(LEGACY_REFRESH_KEY);
  localStorage.removeItem("sessionUsername");
}

/** One-time cleanup: drop duplicate app keys; Cognito keys remain. */
export function migrateAwayFromLegacyAppTokens() {
  clearLegacyAppTokens();
}

export async function getAccessToken() {
  try {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  } catch (error) {
    return readCognitoAccessTokenFromStorage();
  }
}

export async function getIdToken() {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (error) {
    return null;
  }
}

export function getAccessTokenSync() {
  const cognitoToken = readCognitoAccessTokenFromStorage();
  if (cognitoToken) {
    return cognitoToken;
  }
  return localStorage.getItem(LEGACY_ACCESS_KEY);
}

export function hasAccessTokenSync() {
  const token = getAccessTokenSync();
  return !!token && token.length > 0;
}

export function getAccessTokenClaims(accessToken) {
  const splitToken = accessToken?.split(".");
  if (!splitToken || splitToken.length !== 3) {
    return null;
  }
  try {
    return JSON.parse(atob(splitToken[1]));
  } catch (error) {
    return null;
  }
}

export function isAccessTokenNearExpiry(accessToken, bufferSeconds = 10 * 60) {
  const claims = getAccessTokenClaims(accessToken);
  if (!claims?.exp) {
    return false;
  }
  const currentTime = Math.floor(Date.now() / 1000);
  return claims.exp - currentTime < bufferSeconds;
}
